import {
  BottomSpace,
  Container,
  LoadingFlexWrap,
  PopUpWrapper,
  TemplateName,
  TemplateThumbnail,
  WrapperPopUp
} from "./styles";
import React, { useCallback, useRef, useState } from "react";

import { AllMyProjects } from "../../../../dtos/AllMyProjects";
import PopUp from "../../../myprojects/components/PopUp";
import IconPopUp from "../../assets/points-icon.svg";
import CopyIcon from "../../assets/copyProject.svg";
import ArrowUpIcon from "../../assets/arrow-up.svg";
import { useDetectClickOutside } from "react-detect-click-outside";
import api from "../../../../services/api";
import { useNavigate } from "react-router-dom";
import { LoadingFlex } from "../../../login/pages/LoginLazy/styles";
import LoadingEditor from "../../../editor/components/LoadingEditor";
import { ContractAnimation } from "../../../../shared/components/ContractAnimation";
import { useMainHook } from "../../../../hooks/main";

interface Props {
  userDocument: AllMyProjects;
  name: string;
  url: string;
  width?: string;
  height?: string;
  handleMakeCopy: () => void;
  handleChangeProjectsName: () => void;
  handleDownload: () => void;
  handleDelete: () => void;
  handleChooseTemplate: () => void;
  setTemplateIDSelectedPopUp: any;
  handleChangeDocumentName: (
    document: AllMyProjects,
    newDocumentName: string
  ) => void;
  index: number;
  templateIDSelectedPopUp: string;
  loading?: boolean;
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}

const Template: React.FC<Props> = ({
  url,
  name,
  userDocument,
  handleChooseTemplate,
  loading,
  setLoading
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const navigator = useNavigate();

  const {
    createdSharedDocument,
    setCreatedSharedDocument,
    setObjectScreen,
    documentName
  } = useMainHook();

  const closeToggle = useCallback(() => {
    if (isOpen) {
      setIsOpen(false);
    }
  }, [isOpen]);

  const refOutsideClick = useDetectClickOutside({
    onTriggered: closeToggle
  });

  const handleTogglePopUp = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const chooseTemplateBits = async (id?: string) => {
    setLoading(true);
    let selectedTemplate = [];
    try {
      const responseSpecific = await api.get(`user-templates/${id}`);
      selectedTemplate.push(...responseSpecific.data.template.arrayOfPages);
    } catch (err) {
      console.log(err, "error when get specific template");
    }
    if (selectedTemplate.length > 0) {
      try {
        const newProject = {
          template: {
            arrayOfPages: selectedTemplate
          },
          title: `Cópia de ${userDocument.title}`,
          description: "Criando novo projeto de template a partir de uma cópia",
          is_automation: false
        };

        const responseCreateProjectCopied = await api.post(
          "user-templates",
          newProject
        );

        if (responseCreateProjectCopied.status === 200) {
          setObjectScreen(selectedTemplate);
          documentName.current = newProject.title;

          navigator(
            `/editor/my-template/${responseCreateProjectCopied.data.id}`
          );

          setCreatedSharedDocument(true);
        }
      } catch (err) {
        setLoading(false);
        console.log(err, "error when choose template");
        window.alert("Error: Algo deu errado!");
      }
    }
  };

  // if (loading) {
  //   return (
  //     <Container className="grid-item">
  //       <LoadingFlexWrap>
  //         <div className="in-loading">
  //           <ContractAnimation />
  //         </div>
  //       </LoadingFlexWrap>
  //     </Container>
  //   );
  // }

  return (
    <Container className="grid-item">
      <WrapperPopUp type="button" onClick={handleTogglePopUp} isActive={isOpen}>
        {isOpen ? (
          <img src={ArrowUpIcon} alt="" />
        ) : (
          <img src={IconPopUp} alt="" />
        )}
      </WrapperPopUp>

      {isOpen && (
        <PopUpWrapper
          onClick={() => chooseTemplateBits(userDocument.id)}
          ref={refOutsideClick}
        >
          <img src={CopyIcon} alt="" />
          <span>Fazer uma cópia</span>
        </PopUpWrapper>
      )}

      <TemplateThumbnail
        src={url}
        alt=""
        className="img"
        onClick={event => {
          if (event.target === event.currentTarget) {
            handleChooseTemplate();
          }
        }}
      />

      <TemplateName>{name}</TemplateName>
      <BottomSpace></BottomSpace>
    </Container>
  );
};

export default Template;
